import { render, staticRenderFns } from "./BaseAudioRecord.vue?vue&type=template&id=f23e694c&scoped=true&"
import script from "./BaseAudioRecord.vue?vue&type=script&lang=js&"
export * from "./BaseAudioRecord.vue?vue&type=script&lang=js&"
import style0 from "./BaseAudioRecord.vue?vue&type=style&index=0&id=f23e694c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23e694c",
  null
  
)

export default component.exports